<div class="edgar-html">
  @let isFullInfoVisible = isFullInfo();
  @let summaryEdgar = summary();
  @let htmlEdgar = html();

  <div
    class="html"
    [class.full-html]="isFullInfoVisible"
    [innerHTML]="isFullInfoVisible && htmlEdgar ? htmlEdgar : summaryEdgar"
  ></div>

  @if (summaryEdgar) {
    <footer class="show-more-wrapper">
      <button mat-button color="primary" class="show-more-btn" [disabled]="inRequest()" (click)="toggleShowFullInfo()">
        {{ (isFullInfoVisible ? 'common.showLess' : 'common.showMore') | translate }}
      </button>
    </footer>
  }
</div>
